import React from 'react';
import { useSelector } from 'react-redux';
import type { RootState } from 'Store/index';
import { Icon } from '@upsales/components';
import { useTranslation } from 'Components/Helpers/translate';
import { useSoftDeployAccess } from 'App/components/hooks';
import { openDrawer } from 'App/babel/services/Drawer';
import { isProductNewsEnabled } from 'App/helpers/productNewsPage';
import { markProductNewsSeen } from 'App/helpers/productNewsSeen';
import NavbarButton from '../NavbarButton';

/** The release notes, behind a bullhorn next to the bell, counting the ones not seen yet. */
const NavbarProductNews = () => {
	const { t } = useTranslation();
	const hasAccess = useSoftDeployAccess('PRODUCT_NEWS_MODAL');
	const publishedIds = useSelector(({ App }: RootState) => App.metadata?.publishedReleaseNoteIds) ?? [];
	const lastSeenId = useSelector(({ App }: RootState) => App.self?.userParams.lastSeenReleaseNoteId) ?? 0;

	if (!hasAccess || !isProductNewsEnabled() || !publishedIds.length) {
		return null;
	}

	const unseen = publishedIds.filter(id => id > lastSeenId).length;
	const open = () => {
		// Every published release, so the backlog counts as seen too.
		const highest = Math.max(...publishedIds, lastSeenId);
		openDrawer('ProductNewsDrawer', { onSeen: () => markProductNewsSeen(highest) });
	};

	return (
		<NavbarButton className="navbar-product-news" title={t('productNews.title')} onClick={open}>
			<Icon name="bullhorn" color="super-light-green" />
			{unseen ? <div className="notification-badge">{unseen > 99 ? '99+' : unseen}</div> : null}
		</NavbarButton>
	);
};

export default NavbarProductNews;
